import { __awaiter, __generator } from "tslib";
import { logger } from '../../logger';
export function loadClearbitV1(analytics, options) {
    var _this = this;
    var _a;
    if (!options.token) {
        logger.error('Token is missing for the Clearbit intent source. Make sure it is included in your script setup.');
        return;
    }
    var response = sessionStorage.getItem('cb_reveal');
    if (response || ((_a = analytics.group().traits()) === null || _a === void 0 ? void 0 : _a.website)) {
        return;
    }
    var handleClearbitResponse = function (response) { return __awaiter(_this, void 0, void 0, function () {
        var _a, domain, name, geo, category, metrics, traits;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(response === null || response === void 0 ? void 0 : response.company) ||
                        response.type !== 'company' ||
                        !response.company.domain) {
                        return [2 /*return*/];
                    }
                    _a = response.company, domain = _a.domain, name = _a.name, geo = _a.geo, category = _a.category, metrics = _a.metrics;
                    traits = {
                        website: domain,
                        intentSource: 'clearbit',
                        name: name,
                        country: geo.country,
                        industry: category.industryGroup,
                        number_of_employees: metrics.employeesRange,
                        annual_revenue: metrics.estimatedAnnualRevenue,
                    };
                    return [4 /*yield*/, analytics.group(null, traits)];
                case 1:
                    _b.sent();
                    sessionStorage.setItem('cb_reveal', JSON.stringify(traits));
                    return [2 /*return*/];
            }
        });
    }); };
    window.clearbitCallback = handleClearbitResponse;
    var script = document.createElement('script');
    script.src = "https://reveal.clearbit.com/v1/companies/reveal?authorization=".concat(options.token, "&callback=clearbitCallback");
    script.onerror = function () { return logger.error('Failed to load Clearbit script'); };
    document.body.appendChild(script);
}
//# sourceMappingURL=clearbitV1.js.map